import React from 'react';
import { Menu } from 'src/shared/design-system/Icon';
import { SBTitle } from 'src/shared/design-system/SBTitle';
import { PAGE_HEADER_ROLE } from '../consts';
import { useShefDashboardContext } from '../context';
import { Container, Header, SubHeader, TopNavButton } from './styles';

export type PageHeaderProps = {
  className?: string;
  header?: React.ReactNode;
  isAdmin?: boolean;
  subHeader?: React.ReactNode;
};

export const PageHeaderMenu = () => {
  const { navigation } = useShefDashboardContext();
  return (
    <TopNavButton id='sidebarToggleTop' onClick={navigation.toggle}>
      <Menu />
    </TopNavButton>
  );
};

export const PageHeader: React.FC<PageHeaderProps> = (props) => {
  const { className, header, isAdmin, subHeader } = props;
  return isAdmin ? (
    <SBTitle
      title={
        <>
          {header}
          {subHeader ? ' ' : ''}
          {subHeader}
        </>
      }
    />
  ) : (
    <Container className={className} data-role={PAGE_HEADER_ROLE}>
      <PageHeaderMenu />
      {header && <Header>{header}</Header>}
      {subHeader && <SubHeader>{subHeader}</SubHeader>}
    </Container>
  );
};
